import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationService } from 'app/_services/notification.service';
import { WorkflowItemService } from 'app/_services/workflow-items.service';

@Component({
  selector: 'approve-availabilty-modal',
  templateUrl: './approve-availabilty-modal.component.html'
})
export class ApproveAvailabilityModalComponent implements OnInit {
  public readonly rejectionCommentMaxLength = 350;

  @Input() assetId: any;
  @Input() scheduleItem: any;

  public minDate = new Date();
  public saveInProgress = false;
  public endTimeShowChangeOccurred = false;
  public showRejectionForm = false;
  public rejectionForm: string = '';

  constructor(
    private activeModal: NgbActiveModal,
    private workflowItemService: WorkflowItemService,
    private notificationService: NotificationService,
  ) { }

  ngOnInit() {
    this.minDate.setUTCHours(0, 0, 0, 0);
  }

  public get rejectionCommentTooLong(): boolean {
    return this.rejectionForm.length > this.rejectionCommentMaxLength;
  }

  public closeModal() {
    this.activeModal.dismiss();
  }

  public reject() {
    this.showRejectionForm = true;
  }

  public cancelRejection() {
    this.showRejectionForm = false;
    this.rejectionForm = '';
    this.saveInProgress = false;
  }

  public approve() {
    this.saveInProgress = true;
    let body = {
      status: 'APPROVED',
    };

    this.workflowItemService.approveOrRejectItem(this.scheduleItem.id, body).subscribe(() => {
      this.notificationService.notify('success', 'Success', 'Request approved');
      this.activeModal.close('refresh');
    }, error => {
      console.error(error);
      if (error && error.error && error.error.title) {
        this.notificationService.notify('danger', `Couldn't save approval`, `${error.error.title}`);
      } else {
        this.notificationService.notify('danger', `Couldn't save approval`, `Try again later`);
      }
      this.saveInProgress = false;
    });
  }

  public saveRejection() {
    this.saveInProgress = true;

    let body = {
      status: 'REJECTED',
      comments: this.rejectionForm,
    };

    this.workflowItemService.approveOrRejectItem(this.scheduleItem.id, body).subscribe(() => {
      this.notificationService.notify('success', 'Success', 'Request rejected');
      this.activeModal.close('refresh');
    }, error => {
      console.error(error);
      this.notificationService.notify('danger', `Couldn't save rejection`, `Try again later`);
      this.saveInProgress = false;
    });
  }
}
